import { Box, Paper, Avatar, Typography } from '@mui/material';

// PortalPageHeader renders the Prism-admin-style page header card so the
// Organization Services portal matches the main admin console: a colored icon
// avatar + Bitter serif title + Metropolis subtitle, with an optional
// right-aligned action slot (e.g. a button).
export default function PortalPageHeader({
  icon,
  title,
  subtitle,
  action,
  color = '#4698D3',
}) {
  return (
    <Paper
      elevation={0}
      sx={{
        backgroundColor: '#FFFFFF',
        borderRadius: '8px',
        border: '1px solid #E5E5E5',
        p: 3,
        // 24px, matching the Admin console's header-to-first-section gap.
        mb: 3,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          // Headers carry real action buttons; let them drop to a second line
          // instead of crushing the title on narrow viewports.
          flexWrap: 'wrap',
        }}
      >
        <Avatar sx={{ backgroundColor: color, width: 48, height: 48, flexShrink: 0 }}>
          {icon}
        </Avatar>
        <Box sx={{ flex: '1 1 240px', minWidth: 0 }}>
          <Typography
            variant="h4"
            sx={{
              fontFamily: 'Bitter, Georgia, serif',
              fontWeight: 600,
              fontSize: '1.75rem',
              color: '#253E66',
            }}
          >
            {title}
          </Typography>
          {subtitle != null && (
            <Typography
              component="div"
              sx={{
                fontFamily: 'Metropolis, sans-serif',
                fontSize: '0.875rem',
                color: '#999999',
                fontWeight: 500,
                mt: 0.25,
              }}
            >
              {subtitle}
            </Typography>
          )}
        </Box>
        {action && <Box sx={{ flexShrink: 0 }}>{action}</Box>}
      </Box>
    </Paper>
  );
}
